import { SUPPORTED_PRODUCTS } from '../components/ProductVisual/constants';

export const getIsOnlineState = (state, systemId) => state[systemId].online;
export const isProductSupported = (state, systemId) => SUPPORTED_PRODUCTS.includes(state[systemId].product);
export const getHasConfigState = (state, systemId) => state[systemId].config !== null;
export const getIsWebSocketSubscribed = (state, systemId) => state[systemId].subscribed;
